import moment from 'moment';
import Model from 'src/storage/base';
import { upperFirstCharAll } from 'src/helpers';
import { filteredTreatments } from 'src/components/user/components';
import constants from 'src/constants';

const MAX_CHARGE_VALUE = 9999;

class SignupDoctorModel extends Model {
  id = 'signup_doctor';
  persistent = false;
  defaultState = () => ({
    step: 0,

    avatar: null,
    birthday: null,
    images: [null, null, null, null],
    gender: 'other',
    address: '',
    username: '',
    zipcode: '',
    school: moment().year() - 25,
    treatments: [this.defaultTreatments()],
    certificateFiles: [],
    charges: [],
    charge: this.chargeObject(),
    followupDuration: 30
  });
  defaultTreatments = () => ({
    name: '',
    fee: ''
  });

  apiConfig = {
    signupDoctor: {
      url: 'auth/signup',
      validation: {
        lastName: 'lastName',
        firstName: 'firstName',
        username: 'username',
        email: 'emailAddress',
        password: 'password',
        phoneNumber: 'phoneNumber',
        isDoctor: 'boolean'
      },
      cancellable: true
    },
    updateDoctor: {
      url: 'profile/update/doctor',
      validation: {
        username: 'username',
        firstName: 'firstName',
        lastName: 'lastName',
        gender: 'string',
        email: 'emailAddress',
        birthday: 'birthday',
        phoneNumber: 'phoneNumber',
        specialist: 'specialist',
        description: 'description',
        doctorType: 'doctorType',
        institution: 'institution',
        yearOfStarting: 'yearOfStarting',
        treatments: 'treatments',
        address: 'address',
        countryAddress: 'countryAddress',
        certificateFiles: 'certificateFiles',
        cityAddress: 'cityAddress',
        stateAddress: 'stateAddress',
        zipcode: 'zipcode',
        hospitalAddress: 'hospitalAddress',
        hospitalName: 'hospitalName'
      },
      cancellable: true
    },
    updateSpecialist: {
      url: 'profile/update/doctor/specialist',
      validation: {
        specialist: 'specialist',
        description: 'description',
        subSpeciality: 'subSpeciality'
      },
      cancellable: true
    },
    updateQualifications: {
      url: 'profile/update/doctor/qualifications',
      validation: {
        doctorType: 'doctorType',
        institution: 'institution',
        yearOfStarting: 'yearOfStarting'
      },
      cancellable: true
    },
    updateTreatments: {
      url: 'profile/set/treatments',
      validation: {
        key: 'string',
        value: 'treatments'
      },
      cancellable: true
    },
    charges: {
      url: 'profile/update/charges',
      validation: {
        charge: 'charge',
        charges: 'charges'
      },
      cancellable: true
    },
    followupDuration: {
      url: 'profile/update/followupDuration',
      validation: {
        followupDuration: 'number'
      },
      cancellable: true
    },
    updateCertificate: {
      url: 'profile/set/certificateFile',
      validation: {},
      cancellable: true
    },
    currency: {
      url: 'profile/update/currency',
      validation: {
        currency: 'string'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile',
    location: 'initLocation'
  };

  initLocation = (data) => {
    this.setState({
      tempAddress: {
        countryAddress: upperFirstCharAll(data.country) + '_' + data.countryCode,
        countryName: data.country
      }
    });
    this.loadLocation();
  };

  loadLocation = () => {
    if (model.input('countryAddress') === '') {
      this.setState({ ...this.state.tempAddress });
    }
  };
  handleChangeProfile = (key, value) => {
    // this.resetApiState('updateDoctor');
    this.handleChange(key, value);
  };

  chargeObject = (id, user) => {
    const state = {
      first: { office: null, virtual: null },
      followup: { office: null, virtual: null },
      chatTicket: {
        price: null,
        duration: null,
        messagesCount: null,
        extraMessage: null,
        paid: false
      }
    };
    if (id) state.id = id;
    if (user) state.user = user;
    return state;
  };

  onLoad = () => {
    this.resetCharges();
  };

  onHandleChangeProfile = () => {
    this.resetCharges();
  };

  resetCharges = () => {
    let user = this.state.user || {};
    this.resetApiState('charges');

    this.setState({
      currency: user.currency || constants.general.defaultCurrency,
      charge: user.charge ? { ...user.charge } : this.chargeObject(),
      charges: user.charges ? [...user.charges] : [],
      changed: false,
      followupDuration: user.followupDuration || 30
    });
  };

  saveCharges = (cb) => {
    let req = {
      charge: this.state.charge,
      charges: [...this.state.charges]
    };
    this.api('charges', req, (error, data, success) => {
      if (success) {
        this.emit('profile', data);
      }
      cb && cb(error, data, success);
    });
    if (this.invalid.length) {
      cb && cb(this.invalid);
    }
  };

  addCharge = (charge, cb) => {
    this.api('add', { charge, id: charge.id }, (error, data, success) => {
      if (success) {
        this.emit('profile', data);
      }
      cb && cb(error, data, success);
    });
    if (this.invalid.length) {
      cb(this.invalid);
    }
  };

  removeCharge = (charge, cb) => {
    this.api('remove', { id: charge.id }, (error, data, success) => {
      if (success) {
        this.emit('profile', data);
      }
      cb && cb(error, data, success);
    });
  };

  handleCharges = (id, name, key) => (_, value) => {
    if (key !== 'duration' && key !== 'paid') {
      value = parseInt(value) || 0;
      if (value < 0) value = 0;
      if (value > MAX_CHARGE_VALUE) value = MAX_CHARGE_VALUE;
    }
    if (!this.state.changed) this.setStateSilent({ changed: true });
    this.resetApiState('charges');
    if (id === 'default') {
      const charge = this.state.charge;
      if (!charge[name]) charge[name] = {};
      charge[name][key] = value;
      return this.handleChange('charge', charge);
    }
    const charges = this.state.charges.map((charge) => {
      if (charge.id === id) {
        if (!charge[name]) charge[name] = {};
        charge[name][key] = value;
      }
      return charge;
    });

    this.handleChange('charges', charges);
  };

  handleChangeDuration = (followupDuration) => {
    this.handleChange('followupDuration', followupDuration);
    this.api('followupDuration', { followupDuration }, () => {});
  };

  saveSpeciality(cb) {
    let { description, specialist, subSpeciality } = this.state;
    this.api(
      'updateSpecialist',
      { description, specialist, subSpeciality },
      (err, data, success) => {
        if (success) this.emit('profile', data);
        cb && cb(err, data, success);
      }
    );
  }

  saveQualifications(cb) {
    let { doctorType, yearOfStarting, institution } = this.state;
    this.api(
      'updateQualifications',
      { doctorType, yearOfStarting, institution },
      (err, data, success) => {
        if (success) this.emit('profile', data);
        cb && cb(err, data, success);
      }
    );
  }

  saveTreatments(cb) {
    this.api(
      'updateTreatments',
      { key: 'treatments', value: filteredTreatments(this.state.treatments) },
      (err, data, success) => {
        // if (success) this.emit('profile', data);
        cb && cb(err, data, success);
      }
    );
  }

  saveCertificate(cb) {
    this.api(
      'updateCertificate',
      { certificateFiles: (this.input('certificateFiles') || []).filter((item) => !!item) },
      (err, data, success) => {
        // if (success) this.emit('profile', data);
        cb && cb(err, data, success);
      }
    );
  }

  handleProfile = (profile) => {
    if (!this.state.step && profile) {
      this.setStateSilent({ step: this.getStep(profile) });
    }
    this.setStateSilent({ ...profile, profile });
  };

  getStep = ({
    specialist,
    description,
    charge,
    doctorType,
    yearOfStarting,
    institution,
    certificateFiles
  }) => {
    if (!(specialist?.length > 0) || !description) return 0;
    if (!doctorType || !yearOfStarting || !institution) return 1;
    if (!(charge && charge.first && charge.first.virtual !== null)) return 3;
    if (!certificateFiles?.length) return 6;
    return 0;
  };

  handleChangeCurrency = (currency) => {
    this.handleChange('currency', currency);
    this.api('currency', { currency }, () => {});
  };
}

const model = new SignupDoctorModel();
export default model;
